import { useEffect, useState } from "react";
import { EventAutocompleteOption } from "../types";
import { EVENT_SWITCH_DELAY, ODIN_EVENT_EDITION_STORAGE_KEY } from "../../../common/constants";
import OfflineStorage from "common/offlineStorage/OfflineStorage";

export const useEventSelect = (isLogoHeader = false) => {
  const [selectedEvent, setSelectedEvent] = useState("");
  const [shouldEventUpdate, setShouldEventUpdate] = useState(false);

  const handleSave = (atlasId: string) => {
    localStorage.setItem(ODIN_EVENT_EDITION_STORAGE_KEY, atlasId);
  };

  const preselectEvent = () => {
    const fromStorage = localStorage.getItem(ODIN_EVENT_EDITION_STORAGE_KEY);
    if (isLogoHeader) {
      setShouldEventUpdate(false);
    }
    setSelectedEvent(fromStorage || "");
  };

  const detectChange = () => {
    const fromStorage = localStorage.getItem(ODIN_EVENT_EDITION_STORAGE_KEY);
    setShouldEventUpdate(selectedEvent !== fromStorage);
  };

  useEffect(() => {
    detectChange();
  }, [selectedEvent]);

  useEffect(() => {
    preselectEvent();
  }, []);

  useEffect(() => {
    if (shouldEventUpdate && isLogoHeader) saveEvent();
  }, [shouldEventUpdate]);

  const onEventChange = (option: EventAutocompleteOption) => {
    setSelectedEvent(option.atlasId);
  };

  const saveEvent = () => {
    window.indexedDB && window.indexedDB.deleteDatabase("GraphQL-Cache");
    handleSave(selectedEvent);
    setShouldEventUpdate(false);
    OfflineStorage.clearUpLogosFromStorage();
    OfflineStorage.clearUpBadgeImagesFromStorage();
    setTimeout(() => {
      window.location.reload();
    }, EVENT_SWITCH_DELAY);
  };

  const resetEvent = () => {
    const fromStorage = localStorage.getItem(ODIN_EVENT_EDITION_STORAGE_KEY);
    setSelectedEvent(fromStorage || "");
  };

  return { selectedEvent, onEventChange, saveEvent, resetEvent, shouldEventUpdate };
};
